import React from 'react';
import { useI18n } from 'react-simple-i18n';
import { MeasuresQuiz } from './measuresView';
import { Link } from 'react-router-dom';
import { getLocaledString } from '../appstate';

export default function Quiz1() {
	const { t } = useI18n();

	return (
		<div
			className={
				'mb-8 md:mb-0 max-w-8xl px-6 md:px-12 mx-auto relative text-lg mt-8 mb-8 md:mb-0'
			}
		>
			<MeasuresQuiz />
			<div className={'mt-24 '}>
				<Link
					to={'/employees-and-employers#izhodisce'}
					className={'button-tertiary w-fit reversed cursor-pointer'}
				>
					{getLocaledString('Nazaj', 'Back')}
				</Link>
			</div>
		</div>
	);
}
